import React, { Component } from "react";
import JsonViewerCard from "./JsonViewerCard";

export interface AsyncJsonViewerProps {
    title: string;
    getData(): Promise<any>;
}

export interface AsyncJsonViewerState {
    data: any;
    loading: boolean;
}

export class AsyncJsonViewer extends Component<AsyncJsonViewerProps, AsyncJsonViewerState> {

    constructor(props: AsyncJsonViewerProps) {
        super(props);

        this.state = {
            data: undefined,
            loading: true
        };
    }

    public async componentDidMount() {
        if (this.props.getData) {

            const data = await this.props.getData();
            this.setState({
                data,
                loading: false
            });
        }
    }
    

    public render() {
        return <JsonViewerCard title={this.props.title} jsonObject={this.state.data} loading={this.state.loading}/>;
    }
}